'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
const l = ({
  score: r = 0
}) => {
  const a = [
    "Password strength",
    "Weak",
    "Moderate",
    "moderate",
    "Strong",
    "Strong"
  ], n = [
    "bg-grey-200",
    "bg-red-error",
    "bg-yellow-warning",
    "bg-yellow-warning",
    "bg-green-success-dark",
    "bg-green-success-dark"
  ], g = Array.from(
    { length: 5 },
    (t, s) => s < r ? n[r] : "bg-grey-200"
  );
  return /* @__PURE__ */ e.jsxs("div", { className: "w-full", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flex space-x-1", children: g.map((t, s) => /* @__PURE__ */ e.jsx(
      "div",
      {
        className: `h-1 w-1/5 rounded-full ${t} transition-opacity duration-300`
      },
      s
    )) }),
    /* @__PURE__ */ e.jsx("div", { className: "p-1 text-right text-xs text-grey-400", children: a[r] })
  ] });
};
export {
  l as default
};
